import axios from 'axios'
import React, { useState, useContext } from 'react'
import Button from '../../../button/Button'
import Input from '../../../input/Input'
import { baseApiURL } from 'src/utils/utils'
import { IState, IAddress } from 'src/Interface'
import { StateContext } from '../../../../AppContext'
import styles from './add-location.module.scss'
import AutocompletePoi from '../../../autocomplete/AutocompletePoi'
import { toast } from 'react-toastify'
import { validEmail, validString } from 'src/utils/utils'
import { DispatchContext } from 'src/AppContext'


interface IValues {
  name: string
  contactPerson: string
  email: string
  address: IAddress
}

interface IErrors {
  name: boolean
  contactPerson?: boolean
  email?: boolean
}

interface Props {
  close: () => void
  companyId: number
}


const AddLocation: React.FunctionComponent<Props> = ({ close, companyId }: Props) => {
  const state: IState = useContext(StateContext)
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useContext(DispatchContext)
  const [validationErrors, setValidationErrors] = useState<IErrors>({
    name: false,
    contactPerson: false,
    email: false
  })

  const [errors, setErrors] = useState<IErrors>({
    name: false
  })

  const [values, setValues] = useState<IValues>({
    name: '',
    contactPerson: '',
    email: '',
    address: null
  })

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true
    }
    setValidationErrors({
      ...validationErrors,
      [fieldName]: error
    })
  }

  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })

    setValidationErrors({
      ...validationErrors,
      [fieldName]: false
    })
  }


  const handleInputChange = (fieldName: string) => (value: string) => {
    setValues({
      ...values,
      [fieldName]: value
    })
  }

  const createLocation = () => {
    if (values.name && values.address) {
      setIsLoading(true)
      axios.post(`${baseApiURL()}/companies/${companyId}/branches`, {
        name: values.name,
        contactPerson: values.contactPerson,
        address: values.address,
        email: values.email
      }, {
        headers: {
          Authorization: `Bearer ${state.user.accessToken}`
        }
      }).then(() => {
        return null
      }).then(() => {
       return axios(`${baseApiURL()}/companies/${companyId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        })
      }).then((result: any) => {
        setIsLoading(false)
        toast('Afdeling oprettet')
        dispatch({ type: 'SET_COMPANY', company: result.data })
        close()
      }).catch(error => {
        setIsLoading(false)
        if (error.response.data.message.startsWith('Key (company_id, name)=(')) {
          setErrors({
            ...error,
            name: true
          })
        } else {
          if (error.response) {
            toast(error.response.data.message)
          } else {
            toast('Der gik desværre noget galt. Prøv igen om lidt')
          }
        }
      });
    }
  }

  return (
    <div className={styles.addLocation}>
      <header className={styles.header}>
        <h4>Ny lokation</h4>
      </header>
      <div className={styles.container}>
        <div className='tw-mb-3'>
          <Input
            label='Navn *'
            type='text'
            handleInputChange={() => handleInputChange('name')}
            name='name'
            placeholder='Indtast afdelingsnavn'
            error={errors.name}
            resetError={() => resetError('name')}
            handleValidation={() => handleValidation(validString, 'name')}
          />
          {errors.name && <p className='errorMsg'>Lokationsnavnet eksisterer allerede. </p>}
          {validationErrors.name && <p className='errorMsg'>Lokationsnavnet bør være mellem 2 og 32 karakterer.</p>}
        </div>
        <AutocompletePoi
          modifiers='tw-mb-3'
          label='Adresse *'
          setAddress={() => handleInputChange('address')}
          name='addresse'
          placeholder='Indtast adresse'
        />
        <div className='tw-mb-3'>
          <Input
            label='Kontakt person *'
            type='text'
            error={validationErrors.contactPerson}
            resetError={() => resetError('contactPerson')}
            handleValidation={() => handleValidation(validString, 'contactPerson')}
            handleInputChange={() => handleInputChange('contactPerson')}
            name='contactPerson'
            placeholder='Indtast kontaktperson'
          />
          {validationErrors.contactPerson && <p className='errorMsg'>Navnet bør være mellem 2 og 32 karakterer.</p>}
        </div>
        <div className='tw-mb-3'>
          <Input
            label='Email'
            type='email'
            error={validationErrors.email}
            resetError={() => resetError('email')}
            handleInputChange={() => handleInputChange('email')}
            name='email'
            placeholder='Indtast email til kontaktperson'
            handleValidation={() => handleValidation(validEmail, 'email')
            } />
          {validationErrors.email && <p className='errorMsg'>Emailen ser ikke ud til at være i et korrekt format.</p>}
        </div>
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' handleClick={close} />
        <Button loading={isLoading} type='primary' label='Opret lokation' disabled={!(values.name && values.address && values.contactPerson)} handleClick={createLocation} />
      </footer>
    </div>
  )
}

export default AddLocation
